import format from 'date-fns/format';
import { enUS } from 'date-fns/locale';

import { FullScheduleData, ScheduleData } from '@common/types/api';
import { WEEK_DAYS } from '@constants';

export const formatScheduleDisplayData = (
  props: FullScheduleData | ScheduleData,
) => {
  const { schedule_date, start_time, end_time } = props;
  const scheduleDate = new Date(`${schedule_date}T00:00`);

  const formattedDate = format(scheduleDate, 'dd MMMM y', {
    locale: enUS,
  });

  const [, month, year] = formattedDate.split(' ');

  const weekDay = WEEK_DAYS[scheduleDate.getDay()];

  const formatTime = (time: string) => (time ? time.slice(0, 5) : '');
  const timetable = `${formatTime(start_time)} - ${formatTime(end_time)}`;

  return {
    day: scheduleDate.getDate(),
    weekDay,
    timetable,
    formattedDate,
    month,
    year,
  };
};
